export default __webpack_public_path__ + "static/media/panels.ee3a1333.jpg";